export default {
  flat: [
    {
      code: 2465,
      articul: "3FKFS230102",
      size: "5/200",
      boxSize: 1,
    },
    {
      code: 2466,
      articul: "3FKFS230104",
      size: "7,5/200",
      boxSize: 1,
    },
    {
      code: 2467,
      articul: "3FKFS230106",
      size: "10/200",
      boxSize: 1,
    },
    {
      code: 2425,
      articul: "3FKFS230108",
      size: "12,5/200",
      boxSize: 1,
    },
    {
      code: 2468,
      articul: "3FKFS230110",
      size: "15/200",
      boxSize: 1,
    },
    {
      code: 2469,
      articul: "3FKFS230112",
      size: "20/200",
      boxSize: 1,
    },
    {
      code: 2470,
      articul: "3FKFS230114",
      size: "25/200",
      boxSize: 1,
    },
    {
      code: 2471,
      articul: "3FKFS230116",
      size: "30/200",
      boxSize: 1,
    },
    {
      code: 2472,
      articul: "3FKFS230118",
      size: "38/200",
      boxSize: 1,
    },
    {
      code: 2473,
      articul: "3FKFS230120",
      size: "42/200",
      boxSize: 1,
    },
  ],
  volume: [
    {
      code: 2509,
      articul: "3FKSS230204",
      size: "7,5x2,5/100",
      boxSize: 1,
    },
    {
      code: 2474,
      articul: "3FKSS230206",
      size: "10x5/100",
      boxSize: 1,
    },
    {
      code: 2475,
      articul: "3FKSS230210",
      size: "15x5/100",
      boxSize: 1,
    },
    {
      code: 2476,
      articul: "3FKSS230212",
      size: "20x5/100",
      boxSize: 1,
    },
    {
      code: 2477,
      articul: "3FKSS230214",
      size: "25x6,5/100",
      boxSize: 1,
    },
    {
      code: 2478,
      articul: "3FKSS230216",
      size: "30x6,5/100",
      boxSize: 1,
    },
    {
      code: 2479,
      articul: "3FKSS230218",
      size: "38x8/100",
      boxSize: 1,
    },
  ],
}
